module.exports = __webpack_public_path__ + "static/morning-f0fd32dd146594209fb09b85b5d25864.jpg";